import { ProjectBriefForm } from './components/ProjectBriefForm';
import { ConceptCloud } from './components/ConceptCloud';
import { TopNav } from './components/TopNav';
import { SynonymMatrix } from './components/SynonymMatrix';
import { MashupExplorer } from './components/MashupExplorer';
import { useSessionStore, sessionSelectors } from './store/sessionStore';

function App() {
  const activeProject = useSessionStore(sessionSelectors.activeProject);
  const hasSession = Boolean(
    activeProject &&
      (activeProject.concepts.length > 0 ||
        activeProject.synonyms.length > 0 ||
        activeProject.mashups.length > 0)
  );
  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner">
          <h1 className="app-title">Namenym</h1>
          <TopNav />
        </div>
      </header>

      <main className="app-main">
        <section className="panel panel-brief">
          <ProjectBriefForm />
        </section>
        {hasSession && (
          <section className="panel">
            <ConceptCloud />
          </section>
        )}

        {hasSession && (
          <section className="panel">
            <SynonymMatrix />
          </section>
        )}

        {hasSession && (
          <section className="panel">
            <MashupExplorer />
          </section>
        )}
      </main>
    </div>
  );
}

export default App;
